import { render, staticRenderFns } from "./StoreDeskFiscalPrinter.vue?vue&type=template&id=712862de&scoped=true&"
import script from "./StoreDeskFiscalPrinter.vue?vue&type=script&lang=js&"
export * from "./StoreDeskFiscalPrinter.vue?vue&type=script&lang=js&"
import style0 from "./StoreDeskFiscalPrinter.vue?vue&type=style&index=0&id=712862de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712862de",
  null
  
)

export default component.exports